import { Instance } from '@const/consts'

const domain = 'https://qstorage.infologistics.'
const domainBR = 'https://qstorage.ilsbrasil.'

export const dropdownItems = [
  {
    name: Instance.GLOBAL,
    translation: domain + Instance.GLOBAL
  },
  {
    name: Instance.BR,
    translation: domainBR + Instance.BR
  },
  {
    name: Instance.RU,
    translation: domain + Instance.RU
  },
  {
    name: Instance.ZA,
    translation: domain + Instance.ZA
  },
  {
    name: Instance.VN,
    translation: domain + Instance.VN
  },
  {
    name: Instance.UAE,
    translation: domain + 'ae'
  }
]
